import { render, staticRenderFns } from "./AssignmentAddIcon.vue?vue&type=template&id=518b24a8"
import script from "./AssignmentAddIcon.vue?vue&type=script&lang=js"
export * from "./AssignmentAddIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports